
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class BPWhyAlaoGridItem extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  icon!: any

  @Prop({
    type: String,
    required: true,
  })
  title!: string

  @Prop({
    type: String,
    required: true,
  })
  text!: string
}
